<script>
    import RadioWithInput from "./RadioWithInput.svelte";
    import RadioNoInput from "./RadioNoInput.svelte";

    export let data, filter, change;
</script>
<RadioWithInput change={change} data={data[0]} bind:filter={filter}/>
<RadioNoInput change={change} data={data[1]} bind:filter={filter}/>